// aws-config.ts
// Connects the frontend to your AWS backend

export const awsConfig = {
  region: "us-east-1",
  userPoolId: "us-east-1_wBuUbz57l",
  userPoolClientId: "50j38tc4hbsldpr010a6slccb",
  apiUrl: "https://uofc7ezzuk.execute-api.us-east-1.amazonaws.com",
  wsUrl: "wss://z57encsssi.execute-api.us-east-1.amazonaws.com/prod",
  vapidPublicKey: "BAfv-qyuy4a2QcIztS4ec9TTJDpeyC6t1q9dlLhb_z4hwl8CMToiJYW1_N8zap0SQSbSQRua2P73ea-E5n3VKvM",
  stripePublishableKey: "pk_test_51TLmyM0FQSmJpTZMrQfuH9C19FdMFjUqCswT1Bqddd2jd9pt4MeBUYdTVy3MBVXli8aEsjSAwxc3toBHdpZ7koBP00BbZyhBRn",
};
